import classNames from 'classnames/bind';
import { BsX } from 'react-icons/bs';

import styles from './index.module.scss';
import { FAQ } from './constants';

const cx = classNames.bind(styles);

const Modal = ({ setShowModal }) => {
  const hideModal = () => {
    setShowModal(false);
  };

  return (
    <div className={cx('dim')} onClick={hideModal}>
      <div className={cx('modal')}>
        <div className={cx('header')}>
          <h3 className={cx('title')}>FAQ</h3>
          <button type="button" className={cx('close')}>
            <BsX />
          </button>
        </div>
        <div className={cx('scrollable')}>
          <ul className={cx('faq')}>
            {FAQ.map((item, index) => (
              <li key={index}>
                <h4 className={cx('question')}>{item.question}</h4>
                <p className={cx('answer')}>{item.answer}</p>
              </li>
            ))}
          </ul>
          <p className={cx('warning')}>
            <strong>사용시 주의사항</strong>
            <br />
            부드럽고 촉촉한 제형으로 스틱이 부러질 수 있으니 사용할 만큼만 빼내어 사용해주세요.
            <br />
            제품을 먹지 않도록 주의해주세요.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
